
<div class="page">

    <div class="page-header">
        <div class="breadcrumb">
            <p-breadcrumb [model]="breadcrumbs" [home]="homeBreadcrumb"></p-breadcrumb>
        </div>
        <div class="search">
            <input pInputText type="text" (input)="filter(dt, $event)" placeholder="Search..." />           
        </div>
        <div class="actions">
            <button pButton pRipple label="New" icon="pi pi-plus" class="button-action p-button-success p-mr-2" (click)="openNew()"></button>
            <button pButton pRipple label="Delete" icon="pi pi-trash" class="button-action p-button-danger" (click)="deleteSelectedRacks()" [disabled]="!selectedRacks || !selectedRacks.length "></button>
        </div> 
    </div>

    <div class="page-content">
        <p-table #dt 
            [value]="racks"                                                                                                      
            [rows]="10" 
            [paginator]="true" 
            [globalFilterFields]="['position','qrcode','name','description','tags','status','locationName','isInBay','bayName','columnName','levelName','barrel1Name','barrel2Name']"
            [rowsPerPageOptions]="[5,10,25,50,100]"
            [(selection)]="selectedRacks" 
            [resizableColumns]="true"
            [reorderableColumns]="true"
            [rowHover]="true" 
            dataKey="$key"
            styleClass="p-datatable-striped"
            currentPageReportTemplate="{first} to {last} of {totalRecords}" 
            [showCurrentPageReport]="true"
            selectionMode="multiple"
            [columns]="selectedColumns"
            (onRowReorder)="reorder($event)"
            sortField="position" 
            [sortOrder]="1"
            >

            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="max-width:10%">
                    <col style="max-width:20%">
                    <col style="min-width:10%;max-width:80%">
                    <col style="max-width:20%">
                </colgroup>
            </ng-template>
            
            <ng-template pTemplate="caption">
                <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
                selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}" placeholder="Choose Columns"></p-multiSelect>
            </ng-template>

            <ng-template pTemplate="header" let-columns="columns">
                <tr>
                    <th pResizableColumn pSortableColumn="position" style="width: 8rem">
                        Order<p-sortIcon field="position"></p-sortIcon>
                    </th>
                    <th id="qrcode" style="width: 8rem" name="qrcode" pResizableColumn pReorderableColumn pSortableColumn="qrcode" [class]="includesCol('qrcode') ? 'd' : 'h'">QRCode 
                        <p-sortIcon field="name"></p-sortIcon> 
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter> 
                    </th>
                    <th id="name" name="name" pResizableColumn pReorderableColumn pSortableColumn="name" [class]="includesCol('name') ? 'd' : 'h'">Name 
                        <p-sortIcon field="name"></p-sortIcon> 
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
                    </th>
                    <th id="description" name="description" pResizableColumn pReorderableColumn [class]="includesCol('description') ? 'd' : 'h'">Description
                        <p-sortIcon field="description"></p-sortIcon> 
                        <p-columnFilter type="text" field="description" display="menu"></p-columnFilter>
                    </th>
                    <th id="tags" name="tags" pResizableColumn pReorderableColumn [class]="includesCol('tags') ? 'd' : 'h'">Tags
                        <p-sortIcon field="tags"></p-sortIcon> 
                        <p-columnFilter type="text" field="tags" display="menu"></p-columnFilter>
                    </th>
                    <th id="locationName" name="locationName" pResizableColumn pReorderableColumn pSortableColumn="locationName" [class]="includesCol('locationName') ? 'd' : 'h'">
                        <img src="/assets/images/location.png" style="width: 24px; vertical-align: middle;" />
                        Location 
                        <p-sortIcon field="locationName"></p-sortIcon> 
                        <p-columnFilter type="text" field="locationName" display="menu"></p-columnFilter>
                    </th>
                    <th id="isInBay" name="isInBay" pResizableColumn pReorderableColumn pSortableColumn="isInBay" style="width: 10rem" [class]="includesCol('isInBay') ? 'show' : 'hide'">
                        in Bay?
                        <p-sortIcon field="isInBay"></p-sortIcon> 
                        <p-columnFilter type="boolean" field="isInBay" display="menu"></p-columnFilter>
                    </th>
                    <th id="bayNumber" name="bayNumber" pResizableColumn pReorderableColumn pSortableColumn="bayNumber" [class]="includesCol('bayNumber') ? 'd' : 'h'">Bay 
                        <p-sortIcon field="bayNumber"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="bayNumber" display="menu"></p-columnFilter>
                    </th>
                    <th id="columnNumber" name="columnNumber" pResizableColumn pReorderableColumn pSortableColumn="columnNumber" [class]="includesCol('columnNumber') ? 'd' : 'h'">Column 
                        <p-sortIcon field="columnNumber"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="columnNumber" display="menu"></p-columnFilter>
                    </th>
                    <th id="levelNumber" name="levelNumber" pResizableColumn pReorderableColumn pSortableColumn="levelNumber" [class]="includesCol('levelNumber') ? 'd' : 'h'">Level
                        <p-sortIcon field="levelNumber"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="levelNumber" display="menu"></p-columnFilter>
                    </th>
                    <th id="barrels" name="barrels" pResizableColumn pReorderableColumn pSortableColumn="barrels" [class]="includesCol('barrels') ? 'd' : 'h'">
                        <img src="/assets/images-black/ic_barrel.png" style="width: 24px; vertical-align: middle;" />
                        Barrels
                        <p-sortIcon field="barrel1Name"></p-sortIcon> 
                        <p-columnFilter type="text" field="barrel1Name" display="menu"></p-columnFilter>
                        <p-sortIcon field="barrel2Name"></p-sortIcon>
                        <p-columnFilter type="text" field="barrel2Name" display="menu"></p-columnFilter>
                    </th>
                    <th id="isEnabled" name="isEnabled" pResizableColumn pReorderableColumn pSortableColumn="isEnabled" style="width: 10rem" [class]="includesCol('isEnabled') ? 'show' : 'hide'">
                        Enabled
                        <p-sortIcon field="isEnabled"></p-sortIcon> 
                        <p-columnFilter type="boolean" field="isEnabled" display="menu"></p-columnFilter>
                    </th>
                    <th pResizableColumn pReorderableColumn style="width: 8rem">
                        Actions 
                        <!-- <button type="button" pButton pRipple icon="pi pi-file-o" (click)="dt.exportCSV();" class="p-mr-2" pTooltip="CSV" tooltipPosition="bottom"></button> -->
                        <p-tableHeaderCheckbox style="float: right;margin-right:3px" class="checkbox"></p-tableHeaderCheckbox>
                    </th>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rack let-columns="columns" let-index="rowIndex">
                <tr [pReorderableRow]="index" >
                    <td pEditableColumn>
                        <span *ngIf="isReordering && !isFilter" class="pi pi-bars" [pReorderableRowHandle]="index" style="margin-right: 1rem;"></span>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" 
                                (ngModelChange)="modelChangeFn($event, rack)"
                                [ngModel]="rack.position" 
                                (blur)="completePosition(rack)" 
                                (keydown.tab)="completePosition(rack)" 
                                (keydown.enter)="completePosition(rack)"  
                                required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{index}}
                                <!-- ( {{rack.position}} ) -->
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('qrcode') ? 'd' : 'h'">
                        <qrcode [qrdata]="rack.name" [width]="100" [errorCorrectionLevel]="'M'"></qrcode>
                    </td>

                    <td pEditableColumn [class]="includesCol('name') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="rack.name" 
                                (blur)="completeRack(rack)" 
                                (keydown.tab)="completeRack(rack)" 
                                (keydown.enter)="completeRack(rack)" 
                                 required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{rack.name}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('description') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="rack.description"  (blur)="completeRack(rack)" (keydown.tab)="completeRack(rack)" (keydown.enter)="completeRack(rack)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{rack.description}}</span>
                            
                         
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('tags') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <p-chips  id="tags" [(ngModel)]="rack.tags" [separator]="separatorExp" placeholder="tag1, tag2 tag3" (onBlur)="completeRack(rack)" (onAdd)="completeRack(rack)" (onRemove)="completeRack(rack)"></p-chips>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span style="margin-right: 5px;" *ngFor="let tag of rack.tags">
                                    <p-tag >{{tag}}</p-tag>
                                </span>
                               
                       
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('locationName') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [(ngModel)]="rack.locationName" 
                                    [options]="locations"
                                    optionLabel="name"
                                    optionValue="name"
                                    (blur)="completeRack(rack)" 
                                    (keydown.tab)="completeRack(rack)" 
                                    (keydown.enter)="completeRack(rack)" 
                                    placeholder="Any">
                                </p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{rack.locationName}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('isInBay') ? 'd' : 'h'" class="enabled" style="text-align: center;">
                        <p-inputSwitch  [(ngModel)]="rack.isInBay" (onChange)="completeRack(rack)"></p-inputSwitch>
                    </td>

                    <td pEditableColumn [class]="includesCol('bayNumber') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [(ngModel)]="rack.bayNumber" 
                                    [options]="baysNb" 

                                    (onChange)="onChangeBayNb(rack, rack.bayNumber, $event)"

                                    (blur)="onChangeBayNb(rack, rack.bayNumber, $event)" 
                                  
                                    placeholder="Any">
                                </p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{rack.bayNumber}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('columnNumber') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [(ngModel)]="rack.deepNumber" 
                                    [options]="columnsNb" 
                                    (blur)="completeRack(rack)" 
                                    (keydown.tab)="completeRack(rack)" 
                                    (keydown.enter)="completeRack(rack)" 
                                    placeholder="Any">
                                </p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{rack.deepNumber}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('levelNumber') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [(ngModel)]="rack.highNumber" 
                                    [options]="levelsNb" 
                                    (blur)="completeRack(rack)" 
                                    (keydown.tab)="completeRack(rack)" 
                                    (keydown.enter)="completeRack(rack)" 
                                    placeholder="Any">
                                </p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{rack.highNumber}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('barrels') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                              
                                <!-- (blur)="completeRackLocation(rack, rack.barrel1Key)" 
                                (keydown.tab)="completeRackLocation(rack, rack.barrel1Key)" 
                                (keydown.enter)="completeRackLocation(rack, rack.barrel1Key)"  -->

                                <p-dropdown 
                                    [showClear]="true"
                                    appendTo="body" 
                                    [filter]="true"
                                
                                    [ngModel]="rack.barrel1Key" 
                                    (onChange)="checkValue1(rack, rack.barrel1Key, $event)"
                                    (blur)="checkValue1(rack, rack.barrel1Key, $event)" 
                                    (keydown.tab)="checkValue1(rack, rack.barrel1Key, $event)" 
                                    (keydown.enter)="checkValue1(rack, rack.barrel1Key, $event)" 
                                    [options]="barrels" 
                                    optionLabel="name"
                                    optionValue="$key"
                                   
                                    placeholder="Any">
                                </p-dropdown>
                                &nbsp; &nbsp;
                                <p-dropdown 
                                    [showClear]="true"
                                    appendTo="body" 
                                    [filter]="true"
               
                                    [ngModel]="rack.barrel2Key" 
                                    (onChange)="checkValue2(rack, rack.barrel2Key, $event)"
                                    [options]="barrels" 
                                    optionLabel="name"
                                    optionValue="$key"
                                    (blur)="checkValue2(rack, rack.barrel2Key, $event)" 
                                    (keydown.tab)="checkValue2(rack, rack.barrel2Key, $event)" 
                                    (keydown.enter)="checkValue2(rack, rack.barrel2Key, $event)" 
                                    placeholder="Any">
                                </p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <div class="barrels_{{ getRackImage(rack) }}">
                                    <span style="margin-bottom: 25px;background-color: none;text-align: center;width:65px;font-size: 14px;">{{ displayBarrelName(rack.barrel1Key) }}</span>
                                    <span style="margin-bottom: 25px;background-color: none;width:50px">&nbsp;</span>
                                    <span style="margin-bottom: 25px;background-color: none;width:65px;text-align: center;font-size: 14px;">{{ displayBarrelName(rack.barrel2Key) }}</span>
                                </div>
                                
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('isEnabled') ? 'd' : 'h'" class="enabled" style="text-align: center;">
                        <p-inputSwitch  [(ngModel)]="rack.isEnabled" (onChange)="completeRack(rack)"></p-inputSwitch>
                    </td>

                    <td class="row-actions">
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editRack(rack)"></button>
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteRack(rack)"></button>
                        <p-tableCheckbox class="checkbox" [value]="rack"></p-tableCheckbox>
                        
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="summary">
                    <div class="summary-total">
                        Total: {{racks ? racks.length : 0 }} rack{{racks.length > 1? 's': ''}}
                    </div>
                    <div class="summary-export">
                        <button style="margin-right: 10px"type="button" pButton pRipple icon="pi pi-file-o" (click)="exportToCsv()" class="p-mr-2" pTooltip="CSV - Save the selected lines and columns" tooltipPosition="bottom"></button>
                        <button style="margin-right: 10px"type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS - Save all the lines and columns" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF - Save all the lines and columns" tooltipPosition="bottom"></button>
                    </div>
                </div>
            </ng-template>
        </p-table>

    </div>

    <div class="page-footer">
        <div class="p-d-flex">
            <!-- <button type="button" pButton pRipple icon="pi pi-filter" (click)="dt.exportCSV({selectionOnly:true})" class="p-button-info p-ml-auto" pTooltip="Selection Only" tooltipPosition="bottom"></button> -->
        </div>        
    </div>

    <!-- Dialog : confirm -->
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    

    <!-- Dialog : Popup -->
    <p-dialog [(visible)]="rackDialog" [style]="{width: '450px', height: '450px'}" header="Rack" [modal]="true" styleClass="p-fluid" [baseZIndex]='1000'>
        <div class="p-field" style="margin-top: 10px;">
            <label for="title">Name</label>
            <input style="margin-top: 10px;" type="text" pInputText id="name" [(ngModel)]="rack.name" required autofocus />
            <small class="p-error" *ngIf="submitted && !rack.name">Name is required.</small>
        </div>
        <div class="p-field">
            <label for="description">Description</label>
            <textarea style="margin-top: 10px;" id="description" pInputTextarea [(ngModel)]="rack.description" rows="3" cols="20"></textarea>
        </div>
        <div class="p-field">
            <label for="tags" >Tags</label>
            <div style="height: 10px;">&nbsp;</div>
            <p-chips  id="tags" [(ngModel)]="rack.tags" [separator]="separatorExp" placeholder="tag1, tag2 tag3"></p-chips>
        </div>   
        <div class="in-out" style="margin-top: 20px;">
            <button pButton pRipple label="Cancel" icon="pi pi-times" class="button-action p-button-danger p-mr-2" (click)="hideDialog()"></button>
            <button pButton pRipple label="Save" icon="pi pi-check" class="button-action p-button-success" (click)="saveRack()"></button>
        </div>
    </p-dialog>
    
    

</div>







